class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyHeader = this.dataset.sticky;

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };
    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && this.domNodes.headers[0].dataset.transparent === "true";
    this.initAddon();
    this.handleSticky();
    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount();
    }
  }
  handleSticky() {
    let extraSpace = 20;
    const sectionGroups = document.querySelectorAll(".shopify-section-group-header-group");
    sectionGroups.forEach((section) => {
      if (!section.classList.contains("m-section-header") && !section.classList.contains("m-section-scaling-logo")) {
        extraSpace += section.offsetHeight;
      }
    });
    const topBar = document.querySelector(".m-topbar");
    if (topBar) extraSpace += topBar.offsetHeight;

    let lastScroll = 0;
    window.addEventListener("scroll", () => {
      const currentScroll = window.scrollY;
      if (currentScroll <= extraSpace) {
        this.classList.remove(this.classes.scrollUp, this.classes.stuck, this.classes.always);
        document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
        return;
      }

      if (this.stickyHeader === "on_scroll_up") {
        this.classList.add(this.classes.stuck);
      } else if (this.stickyHeader === "always") {
        this.classList.add(this.classes.always);
      }

      if (
        currentScroll > this.headerHeight + extraSpace &&
        currentScroll > lastScroll &&
        !this.classList.contains(this.classes.scrollDown)
      ) {
        this.classList.remove(this.classes.scrollUp);
        document.body.classList.remove(this.classes.headerScrollUp);
        this.classList.add(this.classes.scrollDown);
        document.body.classList.add(this.classes.headerScrollDown);
      } else if (currentScroll < lastScroll && this.classList.contains(this.classes.scrollDown)) {
        this.classList.remove(this.classes.scrollDown);
        document.body.classList.remove(this.classes.headerScrollDown);
        this.classList.add(this.classes.scrollUp);
        document.body.classList.add(this.classes.headerScrollUp);
      }
      lastScroll = currentScroll;
    });
  }
}
customElements.define("m-header", MHeader);

(function maydanMobileNewItemStyle() {
  function setImportant(node, property, value) {
    if (node) node.style.setProperty(property, value, "important");
  }

  function styleMenuItem(indexes, itemStyles, linkStyles, toggleStyles) {
    indexes.forEach(function (index) {
      var item = document.querySelector('#m-menu-drawer .m-menu-drawer__navigation > li.m-menu-mobile__item[data-index="' + index + '"]');
      if (!item) return;

      var link = item.querySelector(":scope > .m-menu-mobile__link");
      var toggle = item.querySelector(":scope > .m-menu-mobile__toggle-button");
      Object.keys(itemStyles).forEach(function (property) {
        setImportant(item, property, itemStyles[property]);
      });
      Object.keys(linkStyles).forEach(function (property) {
        setImportant(link, property, linkStyles[property]);
      });
      Object.keys(toggleStyles).forEach(function (property) {
        setImportant(toggle, property, toggleStyles[property]);
      });
    });
  }

  function styleDesktopMenu() {
    [0, 4].forEach(function (index) {
      var item = document.querySelector('.m-header__desktop .m-menu > li.m-menu__item[data-index="' + index + '"]');
      if (!item) return;
      setImportant(item, "box-shadow", "inset -1px 0 rgba(255, 255, 255, 0.24)");
      setImportant(item.querySelector(":scope > .m-menu__link--main"), "font-weight", "700");
    });

    var newItem = document.querySelector('.m-header__desktop .m-menu > li.m-menu__item[data-index="5"]');
    if (!newItem) return;
    var newLink = newItem.querySelector(":scope > .m-menu__link--main");
    setImportant(newItem, "background", "#F2F8FF");
    setImportant(newItem, "color", "#004F9A");
    setImportant(newLink, "background", "#F2F8FF");
    setImportant(newLink, "color", "#004F9A");
    setImportant(newLink, "font-weight", "700");
  }

  function styleStickyCategoryBack() {
    var backButton = document.querySelector('#m-menu-drawer .m-menu-drawer__navigation > li.m-menu-mobile__item[data-index="0"] > .m-megamenu-mobile > .m-megamenu-mobile__wrapper > .m-menu-mobile__back-button');
    if (!backButton) return;
    setImportant(backButton, "position", "sticky");
    setImportant(backButton, "top", "0");
    setImportant(backButton, "z-index", "5");
    setImportant(backButton, "margin", "0 0 10px");
    setImportant(backButton, "padding", "16px");
    setImportant(backButton, "background", "#fff");
    setImportant(backButton, "border-bottom", "1px solid #E6EEF5");
    setImportant(backButton, "font-weight", "700");
  }

  function applyStyle() {
    var item = document.querySelector('#m-menu-drawer [data-url="/collections/les-nouveautes"]');
    if (item) {
      var link = item.querySelector(".m-menu-mobile__link");
      setImportant(item, "background", "#F2F8FF");
      setImportant(item, "box-shadow", "inset 4px 0 #004F9A");

      if (link) {
        setImportant(link, "background", "#F2F8FF");
        setImportant(link, "color", "#004F9A");
        setImportant(link, "font-weight", "700");
      }
    }

    styleMenuItem([0, 4], {
      background: "#fff",
      "border-top": "1px solid rgba(0, 79, 154, 0.10)",
      "border-bottom": "1px solid rgba(0, 79, 154, 0.10)",
      "box-shadow": "inset 3px 0 rgba(0, 79, 154, 0.70)"
    }, {
      color: "#0B1F3A",
      "font-weight": "700"
    }, {
      color: "#004F9A"
    });

    styleMenuItem([1, 2, 3], {
      background: "#F7FAFC",
      "border-bottom": "1px solid #E6EEF5"
    }, {
      color: "#111827",
      "font-weight": "600"
    }, {
      color: "#111827",
      opacity: "0.65"
    });

    styleDesktopMenu();
    styleStickyCategoryBack();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyStyle);
  } else {
    applyStyle();
  }

  document.addEventListener("shopify:section:load", applyStyle);
  document.addEventListener("click", function () {
    window.setTimeout(applyStyle, 0);
  }, true);
})();
